var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AlphalendClient } from 'alphalend-sdk';
import { getSuiGraphqlUrl, getSuiGrpcOptions } from './rpcEndpoints';
import { marketsArray } from '../data/marketInfo';
export function fetchSwapQuote(_a) {
    return __awaiter(this, arguments, void 0, function* ({ payAmount, payToken, receiveToken, slippageValue, }) {
        var _b;
        if (!payAmount || parseFloat(payAmount) <= 0 || !payToken || !receiveToken) {
            return null;
        }
        try {
            const alphalendClient = new AlphalendClient('mainnet', getSuiGraphqlUrl('mainnet'), getSuiGrpcOptions('mainnet'));
            const payAmountWithoutDecimals = normalizeAmount(payAmount, payToken.decimals || 0);
            const response = yield alphalendClient.getSwapQuote(payToken.tokenId, receiveToken.tokenId, payAmountWithoutDecimals);
            if (!response)
                return null;
            const estimatedAmountOut = parseFloat(response.estimatedAmountOut.toString());
            const receiveAmountDecimal = convertToDecimal(estimatedAmountOut, receiveToken.decimals || 0);
            const minReceivedDecimal = calculateMinTokensReceived(estimatedAmountOut, slippageValue, receiveToken.decimals || 0);
            return {
                payToken,
                receiveToken,
                payAmount,
                receiveAmount: receiveAmountDecimal.toString(),
                slippage: response.slippage,
                minTokensReceived: minReceivedDecimal.toString(),
                rawQuote: (_b = response.rawQuote) !== null && _b !== void 0 ? _b : null,
            };
        }
        catch (error) {
            console.error('[fetchSwapQuote] Error in fetchSwapQuote', error);
            return null;
        }
    });
}
export function getSuppliedAndBorrowedCoinTypes(portfolioLowFreqData, currentMarketId) {
    const coinTypes = [];
    if (!portfolioLowFreqData)
        return coinTypes;
    const allMarketIds = [
        ...new Set([
            ...Object.keys(portfolioLowFreqData.supplied_amounts || {}),
            ...Object.keys(portfolioLowFreqData.borrowed_amounts || {}),
        ]),
    ];
    const ALPHA_COIN_TYPE = '0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA';
    //add Alpha coinType to price update function if user has supplied alpha to lend
    if (allMarketIds.includes('12') && !coinTypes.includes(ALPHA_COIN_TYPE)) {
        coinTypes.push(ALPHA_COIN_TYPE);
    }
    allMarketIds.forEach((marketId) => {
        const market = marketsArray.find((m) => m.id === marketId);
        if (market) {
            coinTypes.push(market.coinType);
        }
    });
    // Add current market if not already included
    if (currentMarketId) {
        const currentMarket = marketsArray.find((m) => m.id === currentMarketId);
        if (currentMarket && !coinTypes.includes(currentMarket.coinType)) {
            coinTypes.push(currentMarket.coinType);
        }
    }
    return coinTypes;
}
export function getBorrowedCoinTypes(portfolioLowFreqData) {
    const borrowedCoinTypes = [];
    if (!portfolioLowFreqData)
        return borrowedCoinTypes;
    const borrowedMarketIds = [
        ...new Set([...Object.keys(portfolioLowFreqData.borrowed_amounts || {})]),
    ];
    borrowedMarketIds.forEach((marketId) => {
        const market = marketsArray.find((m) => m.id === marketId);
        if (market) {
            borrowedCoinTypes.push(market.coinType);
        }
    });
    return borrowedCoinTypes;
}
export function calculateTransactionAmount(swapQuoteObject, selectedToken) {
    if (!swapQuoteObject || !selectedToken)
        return '0';
    const normalizedAmount = normalizeAmount(swapQuoteObject.payAmount, selectedToken.decimals || 0);
    // Return the normalized amount, but keep as string for compatibility
    // Note: normalizeAmount already returns string without decimals
    return normalizedAmount || '0';
}
export function isSwapNeeded(selectedToken, defaultToken, swapQuoteObject) {
    if (!selectedToken || !defaultToken || !(swapQuoteObject === null || swapQuoteObject === void 0 ? void 0 : swapQuoteObject.receiveToken)) {
        return false;
    }
    return selectedToken.symbol !== defaultToken.symbol;
}
export function normalizeAmount(payAmount, decimals) {
    const normalizedAmount = (parseFloat(payAmount) * Math.pow(10, decimals)).toString();
    return normalizedAmount.split('.')[0]; // Remove decimal part
}
export function convertToDecimal(amount, decimals) {
    const amountNum = typeof amount === 'string' ? parseFloat(amount) : amount;
    return amountNum / Math.pow(10, decimals);
}
export function calculateMinTokensReceived(amountOut, slippageValue, decimals) {
    const amountOutNum = typeof amountOut === 'string' ? parseFloat(amountOut) : amountOut;
    const minReceived = (1 - slippageValue / 100) * amountOutNum;
    return convertToDecimal(minReceived, decimals);
}
